module.exports = __webpack_public_path__ + "static/media/SO9265F0.8ce6e281.png";